import * as types from '../types'

export const initialState = {
  username: '',
  usernameValid: false,
  usernameError: '',
  usernameTouched: false,
  validationError: false,
  ssn: '',
  ssnValid: false,
  ssnError: '',
  ssnTouched: false,
  dob: '',
  dobValid: false,
  dobError: '',
  dobTouched: false,
  error: '',
  isComplete: false,
  invalid: false,
  helpIsOpen: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.UPDATE_FORM_USERNAME:
      return Object.assign({}, state, {
        username: payload,
        usernameError: '',
        usernameTouched: true
      })
    case types.UPDATE_FORM_USERNAME_ERROR:
      return Object.assign({}, state, {
        usernameError: payload.usernameError,
        usernameValid: payload.usernameValid,
        usernameTouched: true
      })
    case types.UPDATE_FORM_DOB:
      return Object.assign({}, state, {
        dob: payload,
        dobError: '',
        dobTouched: true
      })

    case types.UPDATE_FORM_DOB_ERROR:
      return Object.assign({}, state, {
        dobError: payload.dobError,
        dobValid: payload.dobValid,
        dobTouched: true
      })
    case types.UPDATE_FORM_SSN:
      return Object.assign({}, state, {
        ssn: payload,
        ssnError: '',
        ssnTouched: true
      })
    case types.UPDATE_FORM_SSN_ERROR:
      return Object.assign({}, state, {
        ssnError: payload.ssnError,
        ssnValid: payload.ssnValid,
        ssnTouched: true
      })
    case types.UPDATE_FORM_SUBMIT_INVALID:
      return Object.assign({}, state, {
        invalid: payload
      })
    case types.UPDATE_FORM_VALIDATION_ERROR:
      return Object.assign({}, state, {
        validationError: payload
      })
    default:
      return state
  }
}
